import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { Heart, ArrowRight, Building2, User } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function PatronRecognition() {
  const [patrons, setPatrons] = useState([]);

  useEffect(() => {
    fetchPatrons();
  }, []);

  const fetchPatrons = async () => {
    try {
      const res = await fetch(`${API}/api/patrons?status=active`);
      if (res.ok) {
        const data = await res.json();
        // Show only public patrons, limit to 5
        setPatrons(data.filter(p => p.visibility === 'public').slice(0, 5));
      }
    } catch (err) { /* silent */ }
  };

  if (patrons.length === 0) return null;

  return (
    <Card data-testid="patron-recognition">
      <CardContent className="p-4">
        <div className="flex items-center gap-2 mb-3">
          <Heart className="w-4 h-4 text-rose-500" />
          <p className="text-[10px] uppercase tracking-widest text-muted-foreground font-semibold">Our Patrons</p>
        </div>
        <div className="space-y-2.5">
          {patrons.map(patron => (
            <div key={patron.id} className="flex items-center gap-2.5" data-testid={`patron-sidebar-${patron.id}`}>
              {patron.logo_url ? (
                <img src={patron.logo_url} alt={patron.name} className="w-7 h-7 rounded object-cover shrink-0" />
              ) : (
                <div className="w-7 h-7 rounded bg-gray-100 flex items-center justify-center shrink-0">
                  {patron.type === 'organization'
                    ? <Building2 className="w-3.5 h-3.5 text-gray-400" />
                    : <User className="w-3.5 h-3.5 text-gray-400" />
                  }
                </div>
              )}
              <div className="min-w-0">
                <p className="text-sm font-medium text-gray-900 truncate">{patron.name}</p>
                {patron.tagline && (
                  <p className="text-[11px] text-gray-500 truncate">{patron.tagline}</p>
                )}
              </div>
            </div>
          ))}
        </div>
        <Link
          to="/patrons"
          className="flex items-center gap-1 mt-3 text-xs text-muted-foreground hover:text-foreground transition-colors font-medium"
          data-testid="view-all-patrons"
        >
          View all patrons <ArrowRight className="w-3 h-3" />
        </Link>
      </CardContent>
    </Card>
  );
}
